<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <h4 class="mb-2">{{ $t("lineOptions.page") }}</h4>
        <div class="items" v-if="paths === undefined">
          <Skeletor v-for="i in 5" height="30" class="mb-1 btn" :key="i" />
        </div>
        <div class="items" v-else>
          <button
            class="btn w-100 text-start"
            v-for="path in paths"
            :class="selectedPath === path.id ? 'btn-primary' : 'btn-simple'"
            :key="path.id"
            v-on:click="selectPath(path.id)"
          >
            {{ path.name }}
          </button>
        </div>
        <h4 class="my-2">{{ $t("topBar.views") }}</h4>
        <div class="items" v-if="tableViews === undefined">
          <Skeletor v-for="i in 5" height="30" class="mb-1 btn" :key="i" />
        </div>
        <div class="items" v-else>
          <button
            class="btn w-100 text-start"
            v-for="view in tableViews"
            :class="selectedView?.id === view.id ? 'btn-primary' : 'btn-simple'"
            :key="view.id"
            v-on:click="selectedView = view"
          >
            {{ view.name }}
          </button>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-if="selectedView">
      <div class="row">
        <div class="col">
          <h2>{{ $t("topBar.manageViews") }}</h2>
          <h4>
            <b>{{ selectedPathName }} / {{ selectedView.name }}</b>
          </h4>
        </div>
        <div class="col-auto">
          <button
            class="btn btn-link text-gray-dark"
            v-on:click="deleteView(selectedView)"
          >
            <BaseIcon name="trash" />
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">{{ $t("topBar.viewName") }}</label>
            <input type="text" class="form-control" v-model="selectedView.name" v-on:change="updateView" />
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t("lineOptions.visibility") }}</label>
            <div>
              <label class="cstm-check dropdown-item">
                <span class="regular-14 text-black mx-2">{{ $t("topBar.private") }}</span>
                <input type="radio" :value="0" v-model="selectedView.visibility" v-on:change="updateView" />
                <span class="checkmark radio"></span>
              </label>
              <label class="cstm-check dropdown-item">
                <span class="regular-14 text-black mx-2">{{ $t("topBar.public") }}</span>
                <input type="radio" :value="1" v-model="selectedView.visibility" v-on:change="updateView" />
                <span class="checkmark radio"></span>
              </label>
              <label class="cstm-check dropdown-item">
                <span class="regular-14 text-black mx-2">{{ $t("topBar.role") }}</span>
                <input type="radio" :value="2" v-model="selectedView.visibility" v-on:change="updateView" />
                <span class="checkmark radio"></span>
              </label>
            </div>
          </div>
          <div class="mb-3" v-if="selectedView.visibility === 2">
            <label class="form-label">{{ $t("topBar.selectRole") }}</label>
            <select class="form-select" v-model="selectedView.role_id" v-on:change="updateView">
              <option v-for="role in roles" :key="role.id" :value="role.id">
                {{ role.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <h5>{{ $t("topBar.filters") }}</h5>
          <div class="white-box p-3">
            <pre class="regular-12">{{ JSON.stringify(selectedView.filters, null, 2) }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
import BaseIcon from "@/components/icons/BaseIcon";

export default {
  name: "TableViewSettings",
  components: {
    BaseIcon,
  },
  data() {
    return {
      paths: [],
      selectedPath: undefined,
      tableViews: undefined,
      selectedView: undefined,
      roles: [],
    };
  },
  computed: {
    selectedPathName() {
      return this.paths.find((p) => p.id === this.selectedPath)?.name;
    },
  },
  mounted() {
    http.fetch("/line-options/paths").then((data) => {
      this.paths = data;
      if (data.length > 0) {
        this.selectPath(data[0].id);
      }
    });
    http.fetch("/users/roles").then((data) => {
      this.roles = data;
    });
  },
  methods: {
    selectPath(pathId) {
      this.selectedPath = pathId;
      this.tableViews = undefined;
      this.selectedView = undefined;
      http.fetch(`/table-views/${pathId}`).then((data) => {
        this.tableViews = data;
        if (data.length > 0) {
          this.selectedView = data[0];
        }
      });
    },
    updateView() {
      http.fetch("/table-views/update", this.selectedView, true);
    },
    deleteView(view) {
      http.fetch("/table-views/delete", { id: view.id }, true).then(() => {
        let i = this.tableViews?.indexOf(view);
        if (i > -1) {
          this.tableViews.splice(i, 1);
          this.selectedView = this.tableViews.length > 0 ? this.tableViews[0] : undefined;
        }
      });
    },
  },
};
</script>
